<div class="wrap" *ngIf="t=='1'">
  <label for="" class="form-label">{{label}}*</label>
  <input type="text" [placeholder]="placeholder" [required]="isRequired" [(ngModel)]="model"
      (ngModelChange)="getZip($event, search_canada)"
      (keydown.enter)="$event.preventDefault();" autocomplete="false" (blur)="checkIfSelected($event)" maxlength="8"
      class="zip-input form-input w-100">
  <!-- <mat-icon class="del-icon" *ngIf="model" (click)="removeZipCode()">delete</mat-icon> -->
  <!-- <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar> -->
</div>


<!-- <label for="" class="form-label">{{label}}*</label>
  <input  type="text"  [placeholder]="placeholder" [required]="isRequired"
  [(ngModel)]="model" (ngModelChange)="getZip($event, search_canada)" [matAutocomplete]="auto"
  (keydown.enter)="$event.preventDefault();" autocomplete="false" (blur)="checkIfSelected($event)" maxlength="8" class="zip-input form-input w-100"> -->




<div class="d-flex align-items-center justify-content-between border_10" *ngIf="t=='2'">
  <div class="custom-form-v5 flex-grow-1" [ngClass]="customClass">
      <input type="text" class="input_field px-3 pt-3" [required]="isRequired" [(ngModel)]="model" [disabled]="disabled"
          (ngModelChange)="getZip($event, search_canada)"  autocomplete="true" maxlength="8" (keypress)="omit_special_char($event)"  (keydown.enter)="$event.preventDefault();" (keydown.backspace)="removeZipCode()" (blur)="checkIfSelected($event)">
      <label for="text" class="label-name">
          <span class="content-name_1 f-c-p-3">
              {{label || 'Zipcode'}}
          </span>
      </label>
      <!-- <img class="del-icon" *ngIf="model" (click)="removeZipCode()" src="assets/img/svg/search-cross.svg"> -->
      <!-- <mat-progress-bar *ngIf="loader" style="position: absolute;bottom: 0;" mode="indeterminate"></mat-progress-bar> -->
  </div>

  <!-- <span style="position: relative;">
     
      <mat-icon class="del-icon-1" *ngIf="model" (click)="removeZipCode()">delete</mat-icon>
  </span> -->
</div>


<div class="bg-white box_zip_options" *ngIf="zipArray.length > 0 && show_options">
  <div class="option-border px-3 py-2 fs-16 fw-600"  *ngFor="let option of zipArray"  (click)="onSelectZip(option)">
      {{option.zip}}
      <small class="fs-16">{{option.city}}{{option.country_code?', '+option.country_code:''}}</small>
  </div>
  <div disabled *ngIf="!zipArray || zipArray.length < 1 && (model && model.length>3) && loader==false">
      {{not_found}}</div>
</div>
